<template>
  <div class="footer">
    <span
      v-for="(item, index) in theFooterNavs"
      :key="index"
      @click="clickCookiePolicy(item)"
    >
      <template v-if="item.value === 'cookie-policy'">{{
        item.label
      }}</template>
      <a
        href="javascript:"
        class="_psaihm_app_oppen_params"
        style="display: inline-block; width: 100%; height: 6rem"
        v-if="item.value === 'cookie-preferences'"
        >{{ item.label }}</a
      >
    </span>
  </div>
</template>
<script>
export default {
  created() {
    this.getFooterNavs();
    this.$store.commit('SET_COOKIE_PREFERENCES', this.langType.slice(0, 2)); // 在当前页设置触发Cookie Preferences
  },
  data() {
    return {
      langType: "en_GB",
      theFooterNavs: [
        {
          value: "cookie-policy",
          label: this.$t("PAGES.layout.CookiePolicy"),
        },
        {
          value: "cookie-preferences",
          label: this.$t("PAGES.layout.CookiePreferences"),
        },
      ],
    };
  },
  methods: {
    getFooterNavs() {
      if (
        localStorage.getItem("lang") &&
        localStorage.getItem("lang") !== "zh_CN"
      ) {
        this.langType = localStorage.getItem("lang");
      } else {
        this.langType = "en_GB";
      }
    },
    clickCookiePolicy(item) {
      if (item.value === "cookie-policy") {
        if (this.$route.fullPath === "/cookie-policy") {
          this.$router.push("/home");
        } else {
          this.$router.push("/cookie-policy");
        }
      } else {
        console.log(123);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.footer {
  background: #000000;
  color: #ffffff;
  font-size: 1.6rem;
  width: calc(100%);
  position: fixed;
  bottom: 0;
  a {
    color: #ffffff !important;
  }
  span {
    display: inline-block;
    height: 6rem;
    line-height: 6rem;
    padding: 0 1rem;
    margin: 0 1rem;
    cursor: pointer;
  }
}
</style>